import { getEncarteThemeSearchResult } from "../../../../../services/EncarteThemeService";

const BASE_URL = process.env.REACT_APP_RESOURCES_BASE_URL;
/**
 * Fetch latest themes with a limit.
 * @param {string} token - Auth token
 * @param {number} limit - Maximum number of themes to fetch
 * @returns {Promise<any>}
 */
export default function useFetchLatestThemes() {
  const fetchLatestThemes = async (token, page = 0, size = 10) => {
    const url = `${BASE_URL}/encartethemes/latest?page=${page}&size=${size}`;
    const res = await fetch(url, {
      headers: { Authorization: token },
    });
    if (!res.ok) throw new Error("Failed to fetch latest themes");
    const json = await res.json();
    return getEncarteThemeSearchResult(token, json);
  };
  return fetchLatestThemes;
}
